import clsx from 'clsx';
import SidebarCrossIcon from '../../assets/icons/sidebar-cross-icon.svg?react';
import React from 'react';
import DatePicker from '../DatePicker';
import TimePicker from '../TimePicker';
import TextArea from '../TextArea';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';

interface RejectActionModalProps {
  otherClasses?: string;
  formHandler: any;
  handleClose: () => void;
}

const RejectActionModal: React.FC<RejectActionModalProps> = ({
  otherClasses,
  formHandler,
  handleClose,
}) => {
  const rejectActionModalClasses = clsx(otherClasses);

  return (
    <div className={rejectActionModalClasses} data-testid="reject-action-modal">
      <div className="mb-6 flex w-full flex-col items-center gap-2.5 text-center lg:mb-9">
        <SidebarCrossIcon className="[&>g>path]:fill-brand-posh-pink h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-posh-pink">Reject this Action & Reopen</h4>
        <p className="font-inter-variable text-brand-posh-pink text-lg leading-5 font-normal">
          Are you sure you want to reject this submission? This action is
          irreversible, and the employee will be notified.
        </p>
      </div>
      <form action="#" onSubmit={formHandler?.handleSubmit}>
        <h6 className="font-inter-variable text-brand-posh-pink text-lg leading-5 font-bold">
          Kindly enter new due date & time.
        </h6>
        <div className="mt-2.5 mb-6 grid grid-cols-1 gap-9 md:grid-cols-2 lg:mb-9">
          <DatePicker
            otherClasses={{
              container: 'w-full',
              dropdownMainContainer: 'top-auto bottom-20 sm:!p-8 !py-8 !p-3',
            }}
            label="Date*"
            name="date"
            value={formHandler?.values?.date}
            startMonth={new Date()}
            endMonth={undefined}
            placeholder="Select date"
            // onBlur={formHandler.handleBlur}
            onBlur={() => {
              if (formHandler?.values?.date) {
                formHandler?.setFieldTouched('date', true);
              }
            }}
            disabled={
              formHandler.isSubmitting ||
              formHandler?.values?.dateTimeUndetermined
            }
            onChange={(e) => formHandler?.setFieldValue('date', e, true)}
            errorMessage={
              formHandler?.touched.date && formHandler?.errors.date
                ? formHandler?.errors.date
                : ''
            }
          />
          <TimePicker
            onBlur={formHandler?.handleBlur}
            label="Time*"
            errorMessage={
              formHandler?.touched.time && formHandler?.errors.time
                ? formHandler?.errors.time
                : ''
            }
            disabled={
              formHandler?.isSubmitting ||
              formHandler?.values?.dateTimeUndetermined
            }
            value={formHandler?.values.time}
            placeholder="Select time"
            onChange={formHandler?.handleChange}
            name="time"
            otherClasses={{ container: 'w-full' }}
          />
        </div>
        <div className="mt-2.5 grid grid-cols-1">
          <TextArea
            name="description"
            onBlur={formHandler?.handleBlur}
            onChange={formHandler?.handleChange}
            value={formHandler?.values?.description}
            placeholder="Write something here e.g. The chemical spill must be cleaned up..."
            disabled={formHandler?.isSubmitting}
            errorMessage={
              formHandler?.touched.description &&
              formHandler?.errors.description
                ? formHandler?.errors.description
                : ''
            }
            label="Description*"
            otherClasses={{ container: 'w-full ' }}
          />
        </div>
        <div className="mt-6 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
          <Button
            variant="secondary"
            type="button"
            size={useButtonSizeSmall()}
            onClick={() => handleClose()}
            otherClasses="text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            size={useButtonSizeSmall()}
            otherClasses="bg-brand-posh-pink hover:text-brand-posh-pink hover:border-brand-posh-pink"
          >
            Reject Submission
          </Button>
        </div>
      </form>
    </div>
  );
};

export default RejectActionModal;
